import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Holiday  {
    _originalTypeClassName = "zSHR.BO.Holiday";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Holiday.translate = translateService;
}
this.Id = null;
this.Date = null;
this.Name = null;
this.IsWorkingDay = false;
this.Type = null;
this.Year = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Date:any;
Name:any;
IsWorkingDay:any;
Type:any;
Year:any;

static ToCalendarEvent($this: any): any{let event = new Domain.CalendarEvent();
event.Id = "Holiday_" + Joove.Common.safeNumber($this?.Id);
event.Title = $this?.Name;
event.Start = (moment($this?.Date).add(12, "h")).toDate();
event.End = (moment($this?.Date).add(12, "h")).toDate();
event.overlap = false;
event.display = "background";
event.allDay = true;
return event;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}